export const STATUS_SELECT_TEMPLATE = Symbol('STATUS_TEMPLATE')
export const STATUS_TEMPLATE_SCREENS = Symbol('STATUS_TEMPLATE_SCREENS')
export const STATUS_DEPLOYMENT = Symbol('STATUS_DEPLOYMENT')
